import { render, staticRenderFns } from "./QuestionsPrev.vue?vue&type=template&id=0bda8050&scoped=true&"
import script from "./QuestionsPrev.vue?vue&type=script&lang=ts&"
export * from "./QuestionsPrev.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsPrev.vue?vue&type=style&index=0&id=0bda8050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda8050",
  null
  
)

export default component.exports